import { Chip } from "@material-ui/core"
export default ({ label }) => <Chip label={label} />